import { FormEvent, useEffect, useState } from 'react'
import * as Yup from 'yup'
import jwt from 'jsonwebtoken'

import * as auth from '../../../api/auth/auth'
import clientes from '../../../api/clientes'
import ceps from '../../../api/ceps'
import defaultOptions from '../../../api/defaultoption'
import { useToast } from '../../../hooks/toast'

import { FormGroup } from '../../Form/styles'
import TextField from '../../TextField'
import {
  addressNumber,
  cepMask,
  noMask,
  noSpecialChars
} from '../../FormPF/masks'
import Loader from '../../Loader'
import * as S from './styles'
import { useMutation } from 'react-query'
import axios from 'axios'
import { AddressProps } from '../../../types/user'
import { queryClient } from '../../../services/queryClient'
import { createNewAddress } from '../../../hooks/address/useAddresses'

const NewAddressForm = ({ setCurrent, inscEstadualIsento, faturamentoUF }) => {
  const { mutateAsync, isLoading, isSuccess, isError, error } = useMutation(
    createNewAddress,
    {
      onSuccess: () => {
        addToast({
          type: 'success',
          title: `Endereço adicionado!`
        })

        queryClient.invalidateQueries('enderecos')
        setCurrent(1)
      },
      onError: () => {
        addToast({
          type: 'error',
          title: 'Erro ao adicionar endereço',
          description: `${error}`
        })
      }
    }
  )

  const { addToast }: any = useToast()

  const token = auth.getToken()
  const userTokenData = jwt.decode(token)
  const userId = parseInt(userTokenData.id)
  const [inputErrors, setInputErrors] = useState<any>({})
  const [load, setLoad] = useState(false)

  const [isCepUnico, setIsCepUnico] = useState(false)

  const [values, setValues] = useState({
    padrao: false,
    id: userId,
    tipoEndereco: 'E',
    apelido: '',
    bairro: '',
    cep: '',
    cidade: '',
    complemento: '',
    logradouro: '',
    numero: '',
    pontoReferencia: '',
    tipoLogradouro: '',
    uf: ''
  })

  const isPromise = (obj) => {
    let result = obj instanceof Promise || (obj && typeof obj.then === 'function');
    return result;
  }

  const checkNewAddressUF = async (uf) => {
    if (isPromise(faturamentoUF)){
      faturamentoUF= await faturamentoUF;
    }
    if (
      !inscEstadualIsento &&
      (faturamentoUF === 'SP' || faturamentoUF === 'RJ')
    ) {
      if (uf === faturamentoUF) {
        return true
      } else {
        addToast({
          type: 'error',
          title:
            'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento',

          timer: 5000
        })
        return false
      }
    } else if (inscEstadualIsento) {
      if (uf === faturamentoUF) {
        return true
      } else {
        addToast({
          type: 'error',
          title:
            'ATENÇÃO: Não é possível cadastrar endereço de entrega com Estado diferente do endereço de faturamento',

          timer: 5000
        })
        return false
      }
    }
  }

  const checkCEPUnico = (cep) => {
    const lastDigits = cep.substr(-3)

    if (lastDigits == '000') {
      // console.log('CEP Unico:', lastDigits)
      setIsCepUnico(true)
    } else {
      // console.log('CEP Válido')
      setIsCepUnico(false)
    }
  }

  async function onBlurCep() {
    // checkCEPUnico(values.cep)
    if (noMask(values.cep).length === 8) {
      setLoad(true)
      const data = await ceps
        .getAddress(noMask(values.cep), defaultOptions)
        .then((res) => {
          if (res.ok) {
            setLoad(false)
            return res.json()
          } else if (!res.body) {
            addToast({
              title: 'Cep não encontrado',
              type: 'error'
            })
          }
        })
        .catch(() => {
          setLoad(false)

          addToast({
            type: 'error',
            title: 'CEP inválido',
            description: `O CEP informado não foi encontrado`
          })
          setValues({
            ...values,
            bairro: '',
            cidade: '',
            complemento: '',
            logradouro: '',
            tipoLogradouro: '',
            uf: ''
          })
        })

      if (data) {
        const { bairro, cidade, complemento, endereco, tipoLogradouro, uf } =
          data

        // console.log('ender', data)

        if (endereco.trim() === '') {
          setIsCepUnico(true)
        } else {
          setIsCepUnico(false)
        }

        // checkNewAddressUF(uf)
        if (!auth.isPF()) {
          if (await checkNewAddressUF(uf)) {
            // checkLogradouro(endereco, bairro)
            setValues({
              ...values,
              bairro: bairro,
              cidade: cidade,
              // complemento: complemento,
              logradouro: endereco,
              tipoLogradouro: tipoLogradouro,
              uf: uf
            })
          } else {
            setValues({
              ...values,
              bairro: '',
              cidade: '',
              complemento: '',
              logradouro: '',
              tipoLogradouro: '',
              uf: ''
            })
          }
        } else {
          // checkLogradouro(endereco, bairro)

          setValues({
            ...values,
            bairro: bairro,
            cidade: cidade,
            // complemento: complemento,
            // logradouro:
            //   endereco === ''
            //     ? `${tipoLogradouro}${endereco}`
            //     : `${tipoLogradouro} ${endereco}`,
            logradouro: endereco,
            tipoLogradouro: tipoLogradouro,
            uf: uf
          })
        }
      }
    }

    if (noMask(values.cep).length < 8 && noMask(values.cep).length > 0) {
      addToast({
        type: 'error',
        title: 'CEP inválido',
        description: `O CEP deve conter 8 dígitos`
      })
      setValues({
        ...values,
        bairro: '',
        cidade: '',
        complemento: '',
        logradouro: '',
        tipoLogradouro: '',
        uf: ''
      })
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setValues({
      ...values,
      [name]:
        name === 'apelido'
          ? noSpecialChars(value.trimStart())
          : value.trimStart()
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleCEPChange = (e) => {
    const { name, value } = e.target
    var t = value;

    setValues({
      ...values,
      [name]: cepMask(value)
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleNumberChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: addressNumber(value)
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const handleBlur = (e) => {
    const { name, value } = e.target

    setValues({
      ...values,
      [name]: value.trimEnd().replace(/  +/g, ' ')
    })
  }

  useEffect(() => {
    if (values.cep.length > 9) {
      onBlurCep()
    }
  }, [values.cep])

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()

    setLoad(true)
    const formData = {
      padrao: false,
      id: userId,
      tipoEndereco: 'E',
      apelido: values.apelido,
      // tipoLogradouro: values.logradouro.trim().split(' ')[0],
      tipoLogradouro: values.tipoLogradouro,
      logradouro: values.logradouro,
      numero: values.numero,
      complemento: values.complemento,
      pontoReferencia: values.pontoReferencia,
      bairro: values.bairro,
      cidade: values.cidade,
      uf: values.uf,
      cep: noMask(values.cep)
    }

    const addressSchema = Yup.object().shape({
      padrao: Yup.bool(),
      id: Yup.number(),
      tipoEndereco: Yup.string(),
      apelido: Yup.string().required('Apelido Obrigatório'),
      bairro: Yup.string().required('Bairro Obrigatório'),
      cep: Yup.string()
        .min(8, 'CEP deve conter 8 caracteres')
        .required('CEP Obrigatório'),
      cidade: Yup.string()
        .required('Cidade Obrigatório')
        .min(3, 'No mínimo 3 caracteres'),
      complemento: Yup.string(),
      tipoLogradouro: Yup.string(),
      logradouro: Yup.string().required('Logradouro é Obrigatório'),
      numero: Yup.string()
        .min(1, 'No mínimo 1 caractere')
        .required('Número Obrigatório'),
      uf: Yup.string().required('UF Obrigatório')
    })
    try {
      await addressSchema.validate(formData, {
        abortEarly: false
      })

      mutateAsync(formData)
    } catch (err) {
      if (err)
        if (err instanceof Yup.ValidationError) {
          const emptyField = Object.values(err.value).every(
            (value) => value !== ''
          )

          if (!emptyField) {
            addToast({
              type: 'error',
              title: 'Preencha todos os campos obrigatórios'
            })

            const errorArray = err.inner.map((error) => {
              return JSON.parse(
                `{"name": "${error.path}", "message": "${error.message}"}`
              )
            })

            const objeto = errorArray.reduce((acc, d) => {
              acc[d.name] = d.message

              return acc
            }, {})
            setInputErrors(objeto)
          } else {
            err.inner.map((error) =>
              addToast({
                type: 'error',
                title: `Erro ao adicionar endereço`,
                description: `${error.message}`
              })
            )
          }
        }
    }
  }

  return (
    <>
      {isLoading ? <Loader></Loader> : null}
      <S.ProfileTitle className="perfil-title">
        Adicionar endereço
      </S.ProfileTitle>
      <S.ProfileBox>
        <form method="POST" id="form-endereco" onSubmit={handleSubmit}>
          <div className="col-4">
            <FormGroup
              className="form-group required"
            // onBlur={onBlurCep}
            >
              <label htmlFor="">CEP</label>
              <TextField
                value={values.cep}
                type="text"
                maxlength={10}
                error={inputErrors.cep}
                name="cep"
                placeholder="Digite o seu CEP"
                required
                onChange={(e) => handleCEPChange(e)}
                autoFocus
                reference={undefined}
                label={undefined}
                onInput={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
              <a
                href="http://www.buscacep.correios.com.br/sistemas/buscacep/BuscaCepEndereco.cfm"
                className="endereco-link-cep"
                target="_blank"
                rel="noopener noreferrer"
              >
                Não sei meu CEP
              </a>
            </FormGroup>
          </div>

          <div className="col-8">
            <FormGroup className="form-group required">
              <label htmlFor="">Apelido</label>
              <TextField
                value={values.apelido}
                error={inputErrors.apelido}
                onBlur={handleBlur}
                type="text"
                maxlength={60}
                name="apelido"
                placeholder="Apelido ao endereço"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-6">
            <FormGroup className="form-group required">
              <label htmlFor="">Logradouro</label>
              <TextField
                value={values.logradouro}
                onBlur={handleBlur}
                type="text"
                maxlength={60}
                name="logradouro"
                placeholder="Logradouro"
                // disabled={isLogradouroDisabled}
                disabled={!isCepUnico}
                error={inputErrors.logradouro}
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-3">
            <FormGroup className="form-group required">
              <label htmlFor="">Número</label>
              <TextField
                value={values.numero}
                error={inputErrors.numero}
                type="text"
                maxlength={11}
                name="numero"
                placeholder="Número "
                required
                className="form-input"
                onChange={(e) => handleNumberChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-3">
            <FormGroup className="form-group">
              <label htmlFor="">Complemento</label>
              <TextField
                onBlur={handleBlur}
                value={values.complemento}
                type="text"
                maxlength={100}
                name="complemento"
                placeholder="Complemento"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                error={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-4">
            <FormGroup className="form-group required">
              <label htmlFor="">Bairro</label>
              <TextField
                onBlur={handleBlur}
                value={values.bairro}
                type="text"
                maxlength={60}
                name="bairro"
                // disabled={isBairroDisabled}
                disabled={!isCepUnico}
                error={inputErrors.bairro}
                placeholder="Bairro"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-6">
            <FormGroup className="form-group required">
              <label htmlFor="">Cidade</label>
              <TextField
                value={values.cidade}
                type="text"
                maxlength={60}
                name="cidade"
                disabled
                placeholder="Cidade"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                error={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-2">
            <FormGroup className="form-group required">
              <label htmlFor="">UF</label>
              <TextField
                value={values.uf}
                type="text"
                maxlength={2}
                name="uf"
                disabled
                placeholder="UF"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                error={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          <div className="col-6">
            <FormGroup className="form-group">
              <label htmlFor="">Ponto de Referência</label>
              <TextField
                onBlur={handleBlur}
                value={values.pontoReferencia}
                type="text"
                maxlength={128}
                name="pontoReferencia"
                placeholder="Ponto de Referência"
                required
                className="form-input"
                onChange={(e) => handleChange(e)}
                reference={undefined}
                label={undefined}
                onInput={undefined}
                error={undefined}
                tooltip={undefined}
                pattern={undefined}
                image={undefined}
                pedidoNegado={undefined}
              />
            </FormGroup>
          </div>

          {/* <FormStyles.FormGroup className="form-group col-7">
            <FormStyles.FormInput
              type="checkbox"
              id="lembrar"
              checked={values.padrao}
              onChange={() => {
                setValues({
                  ...values,
                  padrao: !values.padrao
                })
              }}
            />
            <label htmlFor="lembrar">Definir como endereço padrão</label>
          </FormStyles.FormGroup> */}
        </form>
      </S.ProfileBox>
      <S.ProfileBoxFooter>
        <S.Button
          className="button button-primary"
          type="submit"
          form="form-endereco"
        >
          Salvar Endereço
        </S.Button>
        <S.Button
          className="button button-outline"
          onClick={() => setCurrent(1)}
        >
          Cancelar
        </S.Button>
      </S.ProfileBoxFooter>
    </>
  )
}

export default NewAddressForm
